const drawerContent = {
  root: 'ROOT',
  mailroom: 'MAILROOM',
  recipients: 'RECIPIENTS',
  packageAlertDetails: 'PACKAGE_ALERT_DETAILS',
};

export default drawerContent;
